import { render, staticRenderFns } from "./MirrorShadow.vue?vue&type=template&id=e12cc4f0&scoped=true"
import script from "./MirrorShadow.vue?vue&type=script&lang=js"
export * from "./MirrorShadow.vue?vue&type=script&lang=js"
import style0 from "./MirrorShadow.vue?vue&type=style&index=0&id=e12cc4f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12cc4f0",
  null
  
)

export default component.exports